<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Oferta Anual de Procedimentos</b>
            </h3>
          </div>
          <div class="box-body">
            <div v-if="pdf">
              <embed type="application/pdf" :src="pdf" width="100%" :height="heigthPdf" />
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for>Ano</label>
                  <select class="form-control" name="ano" v-model="filtros.ano">
                    <option value="2026">2026</option>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                  </select>
                </div>
              </div>

			  <div class="col-md-3">
                <div class="form-group">
                	<label for>Mês</label>
                  <select class="form-control" name="mes" v-model="filtros.mes">
					<option value="">-- TODOS --</option>
					<option value="01">Janeiro</option>
					<option value="02">Fevereiro</option>
                    <option value="03">Março</option>
                    <option value="04">Abril</option>
                  	<option value="05">Maio</option>
					<option value="06">Junho</option>
					<option value="07">Julho</option>
					<option value="08">Agosto</option>
					<option value="09">Setembro</option>
					<option value="10">Outubro</option>
					<option value="11">Novembro</option>
					<option value="12">Dezembro</option>
                  </select>
                </div>
              </div>

			  <div class="col-md-4">
					<div class="form-group">
						<label for="">Unidade</label>
						<select-unidade @setUnidadeSelecionada="(unidadeSelecionada)=>{setUnidadeSelecionada(unidadeSelecionada)}"></select-unidade>
					</div>
				</div>

              <div class="col-sm-2 form-group">
                <label>&nbsp;</label>
                  <button
                @click="getDataTable()"
                data-toggle="tooltip"
                title="Buscar"
                class="btn btn-primary form-control"
              >
                <span class="fa fa-search"></span> Buscar
              </button>
              </div>
            </div>

            <div class="row" style="margin-top:15px;" v-if="!isEmpty(dataTable) && !pdf">
              <div class="col-md-12">
                <div class="table-responsive form-group">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Ano</th>
                        <th>Mês</th>
                        <th>Unidade</th>
                        <th>Procedimento</th>
                        <th>Profissional</th>
                        <th class="text-center">Quantidade Disponível</th>
                        <th class="text-center">Quantidade Agendada</th>
                        <th class="text-center">Quantidade Realizada</th>
                        <th class="text-center">Total da Oferta</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in dataTable" :key="item.id">
                        <td>{{item.ano}}</td>
                        <td>{{item.mes}}</td>
                        <td>{{item.unidade}}</td>
                        <td>{{item.procedimento}}</td>
                        <td>{{item.profissional}}</td>
                        <td style="padding: 0">
							<table class="table table-bordered table-striped" style="margin-bottom: 0">
								<thead>
									<tr>
										<th class="text-center">P</th>
										<th class="text-center">R</th>
										<th class="text-center">L</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="text-center">{{item.quantidade_disponivel_primeira}}</td>
										<td class="text-center">{{item.quantidade_disponivel_retorno}}</td>
										<td class="text-center">{{item.quantidade_disponivel_local}}</td>
									</tr>
								</tbody>
							</table>
						</td>
						<td style="padding: 0">
							<table class="table table-bordered table-striped" style="margin-bottom: 0">
								<thead>
									<tr>
										<th class="text-center">P</th>
										<th class="text-center">R</th>
										<th class="text-center">L</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="text-center">{{item.quantidade_agendada_primeira}}</td>
										<td class="text-center">{{item.quantidade_agendada_retorno}}</td>
										<td class="text-center">{{item.quantidade_agendada_local}}</td>
									</tr>
								</tbody>
							</table>
						</td>
                        <td style="padding: 0">
							<table class="table table-bordered table-striped" style="margin-bottom: 0">
								<thead>
									<tr>
										<th class="text-center">P</th>
										<th class="text-center">R</th>
										<th class="text-center">L</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="text-center">{{item.quantidade_realizada_primeira}}</td>
										<td class="text-center">{{item.quantidade_realizada_retorno}}</td>
										<td class="text-center">{{item.quantidade_realizada_local}}</td>
									</tr>
								</tbody>
							</table>
						</td>
                        <td class="text-center">{{item.oferta}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <br />
            <div class="row" v-if="!isEmpty(dataTable)">
              <!-- <div class="col-sm-4">
														Mostrando unidade {{ this.dataTable.from }} de {{ this.dataTable.total }}.
													</div>
													<div class="col-sm-6" style="text-align:right">
														<laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
															<span slot="prev-nav">&lt; Anterior</span>
															<span slot="next-nav">Próximo &gt;</span>
														</laravue-pagination>
              </div>-->
              <div class="col-sm-offset-10 col-sm-2 text-right">
                <button
                  class="btn btn-info pdf"
                  v-show="!pdf"
                  :disabled="finalizado"
                  @click.self.prevent="getPDF"
                >
                  <span class="fa fa-file-pdf-o" aria-hidden="true"></span> PDF
                </button>
              </div>
            </div>
			<div v-else>Nenhum registro encontrado.</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
// import _ from 'lodash'

import selectUnidade from "@/components/cadastros/unidades/selectUnidade";

export default {
  data: () => ({
    pdf: null,
    heigthPdf: 900,
    finalizado: false,
    filtros: {
      ano: new Date().getFullYear(),
      mes: (new Date().getMonth() + 1).toString().padStart(2, '0'),
      unidade_id: ''
    },

    dataTable: []
  }),
  mounted() {
    // this.getDataTable();
  },
  methods: {
    getDataTable() {
      let loader = this.$loading.show()
      this.finalizado = true;
      this.pdf = null;

      this.$store.commit("TOGGLE_LOADING");
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      axios
        .get(
          `${this.$store.state.serverURI}/api/relatorios/ofertasAnual`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
          this.$store.commit("TOGGLE_LOADING");
          this.finalizado = false;
          loader.hide();
        })
        .catch(error => {
          this.$store.commit("throwException", error);
          this.finalizado = false;
          loader.hide();
        });
    },

	setUnidadeSelecionada(unidadeSelecionada) {
		this.filtros.unidade_id = unidadeSelecionada.id;
	},

    getPDF() {
      /*
				this.finalizado = true;
				this.$store.commit('TOGGLE_LOADING');
				axios.post(`${this.$store.state.serverURI}/api/relatorios/ofertasImprimir`, this.filtros, this.$store.getters.getHeaderAuthFile)
					.then(response => {
						this.$store.commit('TOGGLE_LOADING');
						const file = new Blob([response.data], {
							type: 'application/pdf'
						});
						const fileURL = window.URL.createObjectURL(file);
						this.pdf = fileURL;
						let self = this;
						this.heigthPdf = window.innerHeight - 65;
						console.log(window.innerHeight)
						setTimeout(function() {
							self.$refs.filtrar.scrollIntoView();
						}, 300);
						this.finalizado = false;
					}).catch((error) => {
						this.$store.commit('throwException', error);
						this.finalizado = false;
                    });
                    */
    },
    isEmpty(objeto) {
      return Object.values(objeto).every(valor => valor === "");
    }
  },
  components: {
	selectUnidade
  }
};
</script>

<style>
.overflow {
  overflow: auto;
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// index.vue?7ec4f4aa